var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isExit)?_c('IconifyIcon',_vm._b({class:_vm.svgClass,style:(_vm.styleIconifyIcon),attrs:{"icon":_vm.icon}},'IconifyIcon',_vm.$attrs,false)):_c('div',_vm._b({class:_vm.svgClass,style:(_vm.styleExternalIcon),attrs:{"bg-current":""}},'div',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }